import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Popup from "../components/popup.component";
import { useToast } from "../../../../../shared/context/toast/toast-context";
import { IRowData } from "../../../../../shared/contracts/IRowData";
import { ICellRendererParams } from "ag-grid-community";
import useReportingAndAnalyticsApi from "../../useReportingAndAnalyticsApi";
import ConfirmDialog from "../../../../../shared/components/confirm-dialog/confirm-dialog.component";
import useAppStoreContext from "../../../../../shared/context/app-store/app-store.context";

interface IGridCellParams extends ICellRendererParams {
  onRowClick: (id: number) => void;
  data: IRowData;
}

const MenuIconCellRenderer: React.FC<IGridCellParams> = ({
  data,
  onRowClick,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [showPopup, setShowPopup] = useState(false);
  const { showToast } = useToast();
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const { deleteReport, getReportList } = useReportingAndAnalyticsApi();
  const { reportList, setReportList } = useAppStoreContext();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    onRowClick(data.reportId);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const refreshReportList = () => {
    getReportList({
      doIf: () => true,
      onFulfilled: (updatedList) => {
        setReportList(updatedList);
        showToast("Report list refreshed successfully.");
      },
      onException: (error) => {
        showToast(`Failed to fetch updated list: ${error.message}`, "error");
      },
    });
  };

  const handleDelete = (reportId: number, owner: string) => {
    deleteReport(reportId, owner, {
      doIf: () => true,
      doBefore: () => { },
      doAfter: () => { },
      onFulfilled: () => {
        showToast("Report deleted successfully.");
        refreshReportList();
        setShowConfirmDialog(false);
      },
      onException: (error: { message: any }) => {
        showToast(`Failed to delete report: ${error.message}`);
        setShowConfirmDialog(false);
      },
    });
  };

  const handleMenuItemClick = (action: string) => {
    if (action === "Add to Queue") {
      setShowPopup(true);
    } else if (action === "Delete Report") {
      setShowConfirmDialog(true);
      // handleDelete(data.reportId, data.owner); //
    }
    handleClose();
  };

  const handleOnSubmitSuccess = () => {
    showToast("Report Queued Successfully!");
    setShowPopup(false);
  };

  return (
    <>
      {showPopup && (
        <Popup
          open={showPopup}
          rowData={data || []}
          onClose={() => setShowPopup(false)}
          onSubmit={handleOnSubmitSuccess}
        />
      )}
      {showConfirmDialog && (
        <ConfirmDialog
          open={showConfirmDialog}
          onClose={() => setShowConfirmDialog(false)}
          onConfirm={() => handleDelete(data.reportId, data.owner)}
          title="Confirm Deletion"
          message="Are you sure you want to delete this report? This action cannot be undone."
        />
      )}
      <IconButton aria-label="more" aria-haspopup="true" onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleMenuItemClick("Add to Queue")}>
          Add to Queue
        </MenuItem>
       {data.isDelete&&(
        <MenuItem onClick={() => handleMenuItemClick("Delete Report")}>
          Delete Report
          </MenuItem>
       )}
      </Menu>
    </>
  );
};

export default MenuIconCellRenderer;
